import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersService } from 'src/app/services/users.service'
import { HttpService } from '../../services/http.service';
import { FunctionsService } from '../../services/functions.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {

  portailName: String = 'Inscription candidat';
  typeUser: any;
  countryData: any;
  countryList: any[] = [];
  cityList: any[] = [];
  areaActivityList: any[] = [];
  isLoading: boolean = false;

  candidatForm: FormGroup = new FormGroup({});

  consultantForm: FormGroup = new FormGroup({});

  companyForm: FormGroup = new FormGroup({});

  constructor(private formBuilder: FormBuilder, private usersService: UsersService, private httpService: HttpService, public functionsService: FunctionsService) {
  }

  ngOnInit() {
    this.loadCountries();

    this.initCandidateForm();

    this.initConsultantForm();

    this.initCompanyForm();

    this.areaActivityList = this.functionsService.getAreaActivitiesList();

    this.choiceProfile('candidat');
  }

  choiceProfile(profile: any) {
    if (profile == 'candidat') {
      this.typeUser = 'candidat';
      this.portailName = 'Inscription candidat';
    } else if (profile == 'consultant') {
      this.typeUser = 'consultant';
      this.portailName = 'Inscription consutlant';
    } else if (profile == 'entreprise') {
      this.typeUser = 'entreprise';
      this.portailName = 'Inscription entreprise';
    }
  }

  initCandidateForm() {
    this.candidatForm = this.formBuilder.group({
      gender: ['', Validators.required],
      lastName: ['', Validators.required],
      firstName: ['', Validators.required],
      phone1: ['', Validators.required],
      country: ['Benin', Validators.required],
      city: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  initConsultantForm() {
    this.consultantForm = this.formBuilder.group({
      gender: ['', Validators.required],
      last_name: ['', Validators.required],
      first_name: ['', Validators.required],
      phone_1: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  initCompanyForm() {
    this.companyForm = this.formBuilder.group({
      area_activity_id: ['', Validators.required],
      name: ['', Validators.required],
      acronym: ['', Validators.required],
      phone_1: ['', Validators.required],
      country: ['Benin', Validators.required],
      city: ['', Validators.required],
      address: ['', Validators.required],
      nb_person: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  onSubmitForm(typeUser: String) {
    if (typeUser == 'candidat') {
      const formValue = this.candidatForm.value;

      this.isLoading = true;

      this.httpService.registerCandidate(formValue).subscribe(
        (response: any) => {
          if (response.status == "success") {
            let data = response.data;
            localStorage.removeItem('currentAdmin');
            localStorage.removeItem('currentCompany');
            localStorage.removeItem('currentConsultant');
            localStorage.setItem('currentCandidate', JSON.stringify(data));
            this.isLoading = false;
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Inscription effectuée avec succès.',
            }).then(() => {
              window.location.href = window.location.origin + "/accueil/candidat";
            });
          }
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          if (error.error.message == 'EMAIL_ALREADY_USED') {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Cette adresse mail est déjà utilisée.',
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        }
      );
    } else if (typeUser == 'consultant') {
      const formValue = this.consultantForm.value;

      this.isLoading = true;

      this.httpService.registerConsultant(formValue).subscribe(
        (response: any) => {
          if (response.status == "success") {
            let data = response.data;
            localStorage.removeItem('currentAdmin');
            localStorage.removeItem('currentCompany');
            localStorage.removeItem('currentCandidate');
            localStorage.setItem('currentConsultant', JSON.stringify(data));
            this.isLoading = false;
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Inscription effectuée avec succès.',
            }).then(() => {
              window.location.href = window.location.origin + "/compte-consultant";
            });
          }
        },
        (error) => {
          this.isLoading = false;
          if (error.error.message == 'EMAIL_ALREADY_USED') {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Cette adresse mail est déjà utilisée.',
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        }
      );
    } else {
      const formValue = this.companyForm.value;

      this.isLoading = true;

      this.httpService.registerCompany(formValue).subscribe(
        (response: any) => {
          if (response.status == "success") {
            let data = response.data;
            localStorage.removeItem('currentAdmin');
            localStorage.removeItem('currentCandidate');
            localStorage.removeItem('currentConsultant');
            localStorage.setItem('currentCompany', JSON.stringify(data));
            this.isLoading = false;
            Swal.fire({
              icon: 'success',
              title: 'Excellent !',
              text: 'Inscription effectuée avec succès.',
            }).then(() => {
              window.location.href = window.location.origin + "/compte-entreprise";
            });
          }
        },
        (error) => {
          this.isLoading = false;
          if (error.error.message == 'EMAIL_ALREADY_USED') {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Cette adresse mail est déjà utilisée.',
            })
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Vérifier votre connexion puis réessayée.',
            })
          }
        }
      );

    }
  }

  loadCountries() {
    this.httpService.getCountries().subscribe(data => {
      this.countryData = data;
      const countries: any = data;
      let countryList: any[] = [];
      countries.find((item: { country: any; }) => {
        const country = item.country
        if (!countryList.includes(country)) {
          countryList.push(country)
        }
      });

      this.countryList = countryList.sort();

      this.cityList = this.functionsService.findCitiesOfCountry('Benin', this.countryData);
    })
  }

  onChangeCountry(country: string) {
    this.cityList = this.functionsService.findCitiesOfCountry(country, this.countryData);
  }

}
